import { render, staticRenderFns } from "./spent-of-device.vue?vue&type=template&id=f6c52ecc&scoped=true&"
import script from "./spent-of-device.vue?vue&type=script&lang=js&"
export * from "./spent-of-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c52ecc",
  null
  
)

export default component.exports